/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import Header from 'components/Header/Header';
import { RouterUrlEnum } from 'enums/routerUrl';
import { Component } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { AppDispatch, AppState } from 'store';
import { forgotPassword } from 'store/auth/auth.actions';
import { getAuthSpinnerSelector } from 'store/spinner/spinner.selectors';
import { composeValidators, email, required } from 'utils/customValidators';
import { ResetPasswordDTO } from 'utils/restApplicationClient';
import CustomField from '../Input/CustomField';
import { LoginFormContainer, LoginFormLink, LoginFormPageContainer, LoginFormTopBar } from '../Login/LoginForm.styled';

interface IFormValues {
  email: string;
}

interface IMatchProps {
  token: string;
}

interface IStateProps {
  spinner: boolean;
}

interface IDispatchProps {
  forgotPassword: (payload: ResetPasswordDTO) => AppDispatch;
}

type PropType = WithTranslation & RouteComponentProps<IMatchProps> & IDispatchProps & IStateProps;
class ForgotPasswordForm extends Component<PropType> {
  handleSubmit = ({ email }: IFormValues): void => {
    const { forgotPassword, i18n } = this.props;
    forgotPassword({ email, language: i18n.language });
  };

  render(): JSX.Element {
    const { t, spinner } = this.props;

    return (
      <LoginFormPageContainer>
        <Header />
        <Box display="flex" alignItems="center" marginTop="144px" flexDirection="column">
          <LoginFormContainer>
            <LoginFormTopBar>
              <Typography color="textSecondary" component="div">
                <Box fontWeight="fontWeightBold" color="#748392">
                  {t('loginForm.resetPassword')}
                </Box>
              </Typography>
            </LoginFormTopBar>
            <Box padding="12px 24px">
              <Typography color="textSecondary" variant="body2" component="div">
                <Box padding="12px 0">{t('loginForm.resetInfo')}</Box>
              </Typography>
              <FinalForm
                onSubmit={this.handleSubmit}
                subscription={{ submitting: true, pristine: true }}
                render={({ handleSubmit }): JSX.Element => (
                  <form onSubmit={handleSubmit}>
                    <Field
                      name="email"
                      component={CustomField}
                      label="loginForm.labels.email"
                      validate={composeValidators([required, email])}
                    />
                    <Box marginTop="18px">
                      <Button fullWidth variant="contained" color="secondary" type="submit" disabled={spinner}>
                        {spinner ? <CircularProgress size={24} color="secondary" /> : t('loginForm.resetPassword')}
                      </Button>
                    </Box>
                    <LoginFormLink to={RouterUrlEnum.LOGIN}>
                      <Typography color="textSecondary" component="div">
                        <Box fontWeight="fontWeightBold" padding="16px 8px">
                          {t('common.cancel')}
                        </Box>
                      </Typography>
                    </LoginFormLink>
                  </form>
                )}
              />
            </Box>
          </LoginFormContainer>
        </Box>
      </LoginFormPageContainer>
    );
  }
}

const mapStateToProps = (state: AppState): IStateProps => ({
  spinner: getAuthSpinnerSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  forgotPassword: (payload: ResetPasswordDTO): AppDispatch => dispatch(forgotPassword(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ForgotPasswordForm)));
